function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import Topbar from "/components/core/top-bar-new/top-bar-component";
import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";
import { MAIN_ID } from "constants/element-ids";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component"; //new for monday 2.0
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component"; // //new for monday 2.0
import BaseTemplate from "./base-template";
class HomepageTemplate extends PureComponent {
    render() {
        let { children, headerUrl, exitPopup, loginTheme, menuTheme, showMenu, headerBackgroundColor, stickyMode, allowSocialButtons, socialButtonsColor, topBarClassName, topBanner, maxWidth, socialButtonBlogStyle, desktopHeaderLinks, sectionRenderer, mobileHeaderLinks, useV1TopBar } = this.props;
        const HeaderComponent = useV1TopBar ? Topbar : BaseHeaderComponent;
        return /*#__PURE__*/ _jsxs(BaseTemplate, _object_spread_props(_object_spread({}, this.props), {
            children: [
                /*#__PURE__*/ _jsx(HeaderComponent, {
                    url: headerUrl,
                    loginTheme: loginTheme,
                    menuTheme: menuTheme,
                    showMenu: showMenu,
                    headerBackgroundColor: headerBackgroundColor,
                    stickyMode: stickyMode,
                    allowSocialButtons: allowSocialButtons,
                    socialButtonsColor: socialButtonsColor,
                    socialButtonBlogStyle: socialButtonBlogStyle,
                    className: topBarClassName,
                    topBanner: topBanner,
                    maxWidth: maxWidth,
                    headerBackgroundColor: headerBackgroundColor,
                    desktopHeaderLinks: desktopHeaderLinks,
                    sectionRenderer: sectionRenderer,
                    mobileHeaderLinks: mobileHeaderLinks
                }),
                /*#__PURE__*/ _jsx("main", {
                    id: MAIN_ID,
                    children: children
                }),
                /*#__PURE__*/ _jsx(LongFooterComponent, {}),
                /*#__PURE__*/ _jsx(CoreAddonsComponent, {
                    exitPopup: exitPopup
                })
            ]
        }));
    }
}
export { HomepageTemplate as default };
HomepageTemplate.defaultProps = {
    headerUrl: "https://auth.monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    showMenu: true,
    loginTheme: "",
    allowSocialButtons: false,
    headerBackgroundColor: "transparent",
    maxWidth: "100%",
    useV1TopBar: false
};
